<!--
 - Author : 003.
 - Date   : 2019/6/4.
 - File   : ckTitle.仓库区
 -->

<template>
  <div class="ck-title">
    <span class="squ"></span>
    <span class="txt">{{title}}</span>
    <span class="tips" v-if="tips">{{tips}}</span>
    <div class="ck-ct">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ckTitle',
  data () {
    return {
    }
  },
  props: {
    title: {
      type: String,
      default: '今日入库'
    },
    tips: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .ck-title{
    padding-top: 15px;
    text-align: left;
    border-top: 1px solid rgba(32, 138, 139, .5);
    .squ{
      display: inline-block;
      margin-right: 5px;
      width: 15px;
      height: 15px;
      vertical-align: middle;
      background: @darkBlue;
    }
    .txt{
      color: #fff;
    }
    .tips{
      color: @lightBlue;
    }
    .ck-ct{
      padding: 11px 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/ckTitle.vue